<td
  *ngFor="let f of field.fieldGroup"
  class="text-left border border-gray-150 text-black text-xs"
>
  <formly-field [field]="f"></formly-field>
</td>
